import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './BenchmarkToggle.css';

const BenchmarkToggle = ({ data, vertical, onToggle, formatter }) => (
    <div className={cn('benchmark-toggle', { vertical: !!vertical })}>
        {data.map((ele) => (
            <label key={ele.label} htmlFor={`bt-${ele.label}`}>
                <div className="legend-row">
                    <input
                        type="checkbox"
                        id={`bt-${ele.label}`}
                        value={ele.label}
                        onClick={(e) => onToggle(e.target.value, e)}
                        defaultChecked={ele.checked}
                        style={{ backgroundColor: ele.color }}
                    />
                    <div className="text">
                        <div className="label" style={{ color: ele.color }}>
                            {ele.label}
                        </div>
                        <div className="value">{formatter(ele.value)}</div>
                    </div>
                </div>
            </label>
        ))}
        <style jsx>{styles}</style>
    </div>
);

BenchmarkToggle.defaultProps = {
    vertical: false,
    data: [],
    onToggle: () => {},
    formatter: (x) => x
};

BenchmarkToggle.propTypes = {
    /**
     * Data elements to represent in the legend
     */
    data: PropTypes.instanceOf(Array),
    /**
     * Orientation of the legend
     */
    vertical: PropTypes.bool,
    /**
     * toggle event callback
     */
    onToggle: PropTypes.func,
    /**
     * formatter/render fn for value
     */
    formatter: PropTypes.func
};

export default BenchmarkToggle;
